export default () => {
  let modal = document.querySelectorAll(".team-member-modal");
  let modalClose = document.querySelectorAll(".close-modal");
  let member = document.querySelectorAll(".team-member");

  member.forEach(function (displayModal) {
    displayModal.addEventListener("click", function () {
      let modalId = this.getAttribute("id");
      console.log(modalId);
      document.getElementById("modal" + modalId).classList.add("show-modal");
      console.log("open modal");
    });
  });

  modalClose.forEach(function (closeModal) {
    closeModal.addEventListener("click", function () {
      modal.forEach(function (closeModal) {
        closeModal.classList.remove("show-modal");
      });
    });
  });
};
